// Mirrors Tailwind's `md` breakpoint. Keep in sync with the theme if that ever changes.
export const DESKTOP_MEDIA_QUERY = '(min-width: 768px)';
